/**
 * Shares Variables
 * ----------------
 * handles variables shared among all the Shares Classes
 */
let language = document.querySelector("html").getAttribute("lang");
export const lang = language.substring(0, 2);

export const portfolioLink = document.querySelector(".comparison-link") ? document.querySelector(".comparison-link").value : '';

export let toComparisonButtonText = 'Comparison';
export let sharesURLExternal = 'https://www.bbbiotech.ch/all-en/all/portfolio-strategy/performance-portfolio/our-investments';
export let decimalPoint = '.';
export let thousandsSep = "'";

if(lang == 'de'){
  thousandsSep = ' ';
  toComparisonButtonText = 'zum Vergleich';
  sharesURLExternal = 'https://www.bbbiotech.ch/all-de/all/portfolio-strategie/performance-portfolio/unsere-investments';
} else if(lang == 'it'){
  toComparisonButtonText = 'Raffronto';
  sharesURLExternal = 'https://www.bbbiotech.ch/all-it/all/portafoglio-strategia/performance-portafoglio/partecipazioni';
}

const dropDownFileSelector = ".csv-file--dropdown";
const filterFileSelector = ".csv-file--filter";
const sharesFileSelector = ".csv-file--shares";
const dropDownContainerSelector = "#dropdowns";
const sharesContainerSelector = "#shares";
const filtersContainerSelector = "#filters";
const sortingInputsSelector = 'input[name="sorting"]';
const viewSwitchSelector = 'input[name="view-switch"]';

export const dropDownContainer = document.querySelector(dropDownContainerSelector);
export const sharesContainer = document.querySelector(sharesContainerSelector);
export const filterSContainer = document.querySelector(filtersContainerSelector);

export const dropDowns = [...document.querySelectorAll(dropDownFileSelector)];
export const shares = [...document.querySelectorAll(sharesFileSelector)];
export const filters = [...document.querySelectorAll(filterFileSelector)];

export const sorters = [...document.querySelectorAll(sortingInputsSelector)];

export const viewSwitches = [...document.querySelectorAll(viewSwitchSelector)];

export const tiles = [];

export const filtersArr = [];
export const filterVals = [];
export const numMins = [];
export const numMaxs = [];

export const currentView = 'tile';
